// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
var showUnit = {
    show: function (v) {
        return "unit";
    }
};
export {
    unit
} from "./foreign.js";
export {
    showUnit
};
//# sourceMappingURL=index.js.map
